export default __webpack_public_path__ + "static/media/O_apple.a2552c06.png";